/**
 * Created by alex.y on 8/8/2017.
 */
export enum OrderStatus{
    Calculated = 0,
    Quoted,
    Paid,
    Refunded,
    PrepareDoc,
    SentToCustom,
    CustomReleased,
    BorderCrossed,
    Closed = 8
}


// WEBPACK FOOTER //
// ./app/objects/orders/orderStatus.ts